export class CriticalityModel {
  id: number;
  name: string;
  accountId: number;
  threshold: number;

  constructor(data: any) {
    this.id = data.id ? data.id : 0;
    this.name = data.name ? data.name : '';
    this.threshold = data.threshold ? data.threshold : 0;

    this.accountId = data.accountId ? data.accountId : null;
  }
}
